<panel>
	<h1>{{ 'user-settings.header' | translate}}</h1>
	@if (loading){
		<skeletons width="100" [defaultSkeletons]="3" />
	}
	@else {
		<h2>{{ 'user-settings.dashboard.header' | translate}}</h2>
		<section one-column>
			@for (element of dashboardElements; track element) {
				<card
					[sortable]="dashboardElements"
					[item]="element"
					(sortend)="updateElementsSortOrder(dashboardElements)"
					handleSelector="[header]">
					<section header>
						<h3>{{ element.name }}</h3>
					</section>
					<section>
						<custom-input [inputType]="inputType.Checkbox" [label]="'user-settings.dashboard.column-active' | translate" [value]="!element.settings.isExcluded" (valueChange)="element.settings.isExcluded = !$event" />
					</section>
				</card>
			}
		</section>
		<section>
			<button confirm #saveButton (click)="save()">{{ 'general.save' | translate }}</button>
		</section>
	}
</panel>
